/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-02-21 11:06:16
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-02-21 13:36:02
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ope/src/directive/debounce/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import _debounce from 'lodash/debounce'
let fn = null
const debounce = {
  inserted: function (el, binding) {
    fn = _debounce(binding.value, 500, {
      leading: true,
      trailing: false
    })
    el.addEventListener('click', fn)
  },
  unbind: function (el) {
    fn && el.removeEventListener('click', fn)
  }
}
export default debounce
//使用方法
//无参数
//<div v-debounce="fn"></div>
//有参数
//<div v-debounce="()=>fn('submit')></div> 